<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <div
    class="form-group"
    :data-qa="dataQa ? `${dataQa}_container` : null"
  >
    <label
      v-if="label"
      :data-qa="dataQa ? `${dataQa}_label` : null"
    >
      <svg-icon
        v-if="label.icon"
        :icon="label.icon"
        class="label-left-icon"
        :data-qa="dataQa ? `${dataQa}_label_left_icon` : null"
      />
      {{ label.text }}
    </label>
    <div
      class="position-relative"
      :data-qa="dataQa ? `${dataQa}_input_container` : null"
    >
      <svg-icon
        v-if="lefticon"
        :icon="lefticon"
        class="lefticon"
        :data-qa="dataQa ? `${dataQa}_left_icon` : null"
      />
      <select
        v-model="value"
        class="form-control"
        type="text"
        :class="hasRightIcon + ' ' + hasLeftIcon"
        :placeholder="placeholder"
        :data-qa="dataQa"
      >
        <option
          v-for="option in options"
          :key="option[optionValueKey]"
          :selected="selectedValue === option[optionValueKey]"
          :value="option[optionValueKey]"
        >
          {{ option[optionLabelKey] || option[optionValueKey] }}
        </option>
      </select>
      <svg-icon
        v-if="righticon"
        :icon="righticon"
        class="righticon"
        :data-qa="dataQa ? `${dataQa}_right_icon` : null"
      />
    </div>
    <small
      id="emailHelp"
      class="form-text status-message"
      :data-qa="dataQa ? `${dataQa}_message_container` : null"
    >We'll never share your email with anyone else.</small>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    label: {
      type: Object,
      default: null
    },
    lefticon: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    optionLabelKey: {
      type: String,
      default: 'text'
    },
    optionValueKey: {
      type: String,
      default: 'value'
    },
    placeholder: {
      type: String,
      default: null
    },
    righticon: {
      type: String,
      default: null
    },
    selectedValue: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      value: null
    };
  },
  computed: {
    hasRightIcon () {
      return this.righticon ? 'has-right-icon' : '';
    },
    hasLeftIcon () {
      return this.lefticon ? 'has-left-icon' : '';
    }
  },
  created () {
    this.value = this.selectedValue;
  }
};
</script>

<style scoped>
</style>
